export default "__VITE_ASSET__DxUA_olN__"